var _path, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 20C15.5228 20 20 15.5228 20 9.99999C20 4.47714 15.5228 0 9.99999 0C4.47714 0 0 4.47714 0 9.99999C0 15.5228 4.47714 20 9.99999 20Z",
    fill: "#434C59"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.14893,
    y: 8.51064,
    width: 1.70213,
    height: 7.23404,
    rx: 0.540541,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5.74468,
    r: 1.06383,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBlack);
export default __webpack_public_path__ + "static/media/Icon_Info_Black.8654c71d6f9b73ead136764bf102adbc.svg";
export { ForwardRef as ReactComponent };